import {Injectable} from '@angular/core';

export interface IAbout {
  img: string;
  header: string;
  description: string;
  num: string;
}

@Injectable({
  providedIn: 'root'
})
export class AboutUsServiceBusiness {

  data = [
    {
      img: 'assets/img/culture.svg',
      header: 'Культура турботи',
      description: 'Інвестиції у ментальне здоров’я покращують імідж компанії як роботодавця. Демонстрація турботи про співробітників підвищує їх лояльність. Зменшує рівень стресу та вигоряння. Позитивно впливає на командну ефективність. Знижує плинність кадрів.',
      num: '01'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Простота інтеграції',
      description: 'Anima легко впроваджується у ваші внутрішні процеси. Онлайн-скринінг з мінімальним втручанням у робочий день співробітників. Гнучкість для компаній з гібридним чи дистанційним форматом роботи. Легка масштабованість для організацій будь-якого розміру.',
      num: '02'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Конфіденційність і безпека',
      description: 'Anima з особливою турботою дбає про конфіденційність. Тому ми не використовуємо жодні персональні дані. Камера використовується виключно для визначення маркерів погляду і записує лише його координати.',
      num: '03'
    },
    {
      img: 'assets/img/about-icon.png',
      header: 'Наукова точність',
      description: 'Anima поєднує в собі технологію ай-трекінгу з добре відомими психометричними тестами та аналізує біомаркери уваги. Така комбінація технологій і науки дозволяє більш точно (80-93%) оцінити різні психічні стани : тривогу, депресію, вигорання та рівень стресу, навіть у ситуаціях, де самооцінка може бути ненадійною.',
      num: '04'
    }
  ];

  constructor() {
  }

  getList() {
    return this.data;
  }

  private createItem(prop: IAbout): IAbout {
    return {
      img: prop.img,
      header: prop.header,
      description: prop.description,
      num: prop.num
    };
  }
}
